import React from "react";

const ThinCross = ({ ...rest }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="22"
            viewBox="0 0 23 22"
            fill="none"
            {...rest}
        >
            <path
                d="M13.19 10.5913L22.7235 1.81471C22.9119 1.61218 23.0103 1.35166 22.9991 1.08521C22.988 0.818758 22.868 0.566005 22.6632 0.377457C22.4584 0.188908 22.1838 0.078451 21.8944 0.0681592C21.605 0.0578675 21.322 0.148499 21.102 0.321942L11.5685 9.09856L2.03498 0.311355C1.81843 0.111998 1.52472 0 1.21848 0C0.912228 0 0.618524 0.111998 0.401975 0.311355C0.185426 0.510712 0.0637695 0.781098 0.0637695 1.06303C0.0637695 1.34496 0.185426 1.61535 0.401975 1.81471L9.94697 10.5913L0.401975 19.3679C0.281591 19.4629 0.183818 19.5796 0.114791 19.711C0.0457641 19.8423 0.00697439 19.9854 0.00085697 20.1312C-0.00526045 20.277 0.0214258 20.4224 0.0792416 20.5583C0.137057 20.6941 0.224754 20.8175 0.336827 20.9207C0.4489 21.0239 0.58293 21.1046 0.730503 21.1578C0.878077 21.211 1.03601 21.2356 1.19439 21.23C1.35276 21.2243 1.50817 21.1886 1.65084 21.1251C1.79351 21.0615 1.92038 20.9715 2.02347 20.8607L11.5685 12.0841L21.102 20.8607C21.322 21.0342 21.605 21.1248 21.8944 21.1145C22.1838 21.1042 22.4584 20.9937 22.6632 20.8052C22.868 20.6166 22.988 20.3639 22.9991 20.0974C23.0103 19.831 22.9119 19.5705 22.7235 19.3679L13.19 10.5913Z"
                fill="white"
            />
        </svg>
    );
};

export default ThinCross;
